import { Component, OnInit, AfterViewInit,Input, SimpleChanges } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../../core/auth/auth.service';
import { UserService } from '../../../core/user.service';
import * as Chart from "chart.js";
import { bloomAdd } from '@angular/core/src/render3/di';
import {MatDialog, MatDialogConfig} from "@angular/material";
import { LogUploadModalComponent } from '../../../_models/log-upload-modal/log-upload-modal.component';
@Component({
  selector: 'app-cqmns-log-analytics',
  templateUrl: './cqmns-log-analytics.component.html',
  styleUrls: ['./cqmns-log-analytics.component.css']
})
export class CqmnsLogAnalyticsComponent implements OnInit {

  
  projectId: any;
  hostUrl;
  websiteDetails: any;
  websiteName: any;
  fromdate: any;
  toDate: any;
  val:any;
  userId: any;
  constructor(private http: HttpClient,
    private route: ActivatedRoute,
    private userService: UserService, private authService: AuthService, 
    private dialog: MatDialog) { }

  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
    this.hostUrl = this.userService.getUrl();
    this.userId = localStorage.getItem("userid");
    this.projectId = localStorage.getItem("projectId");
    this.val = "true"
    this.http
    .get(
      encodeURI(
        this.hostUrl +
          "/api/issue/websiteNamefromLog/" +
          this.projectId 
      )
    )
    .subscribe(data => {
    
    this.websiteDetails = data;
    this.websiteName = this.websiteDetails[0].websiteName;
    this.fromdate = this.websiteDetails[0].startDate;
    this.toDate = this.websiteDetails[0].endDate
 
  });
  
  }
  openDialogLog() {

  
     const dialogRef = this.dialog.open(LogUploadModalComponent, {
       data: {
         'projectId': this.projectId,
         'addServer': 'false'
       },
               width: '50%',
       
           });
           dialogRef.afterClosed().subscribe(result => {
            this.val = "false"
            this.onChange(this.val);
           });
   }

   onChange(val){
      console.log('in popup',this.val)
      }  
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqmns-log-analytics/cqmns-log-analytics.component.ts